import React from "react";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {styles} from "./../../styles/documents";
import {withStyles} from "@material-ui/core/styles";
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
import {getContestsLevelsEduUnique} from "@helpers/functions";
import {filterTemplatesDocumentsForZajavls} from "@helpers/functions";
import HelperText from "../simple/helper_text";
import {withTranslation} from "react-i18next";

class TemplatesDocuments extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {zajavl, templatesDocuments, t, i18n} = this.props;
        const currentLang = i18n.language;
        const contests = zajavl.contests;
        const contestsLevelsEduUnique = getContestsLevelsEduUnique(contests);
        const templatesDocumentsFiltered = filterTemplatesDocumentsForZajavls(templatesDocuments, zajavl.status, contestsLevelsEduUnique);
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {t('document_templates')}:
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <HelperText
                        message={
                            currentLang === 'en'
                                ? 'Download and fill out the required documents. Sign and attach the documents to your application. ' +
                                'Please note! The scan of the signed documents must be in PDF format, with both pages in a single file.'
                                : 'Скачайте и заполните необходимые документы. Подпишите и прикрепите документы к заявке.Обратите внимание! ' +
                                'Скан подписанных документов должен быть в формате PDF, обе страницы должны быть в одном файле.'}/>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {Object.keys(templatesDocumentsFiltered).length > 0
                            ? Object.keys(templatesDocumentsFiltered).map(groupDocuments => {
                                return (
                                    <Grid item xs={12} key={groupDocuments}>
                                        <ul>
                                            {templatesDocumentsFiltered[groupDocuments].map(document => {
                                                return (
                                                    <li key={document.id}>
                                                        <Link href={document.href} target="_blank">
                                                            <Typography variant="body1">{document.title}</Typography>
                                                        </Link>
                                                    </li>
                                                )
                                            })}
                                        </ul>
                                    </Grid>
                                )
                            })
                            : <Grid item xs={12}><Typography variant="body1">{t('no_templates')}</Typography></Grid>}
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

function mapStateToProps(state) {
    return {
        templatesDocuments: state.templatesDocuments,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(withTranslation()(TemplatesDocuments));